import { Navbar } from "./components/Navbar";
import { CustomCursor } from "./components/CustomCursor";
import { HeroSection } from "./components/HeroSection";
import { ExperienceSection } from "./components/ExperienceSection";
import { PortfolioSection } from "./components/ProjectsSection";
import { ContactAndFooter } from "./components/ContactAndFooter";

import './index.css'; // Ovo treba biti prisutno
import { ServicesSection } from "./components/ServicesSection";

import { useSaveScrollPosition, useRestoreScrollPosition } from "./components/SaveScrollPosition";

const App = () => {
  useSaveScrollPosition();
  useRestoreScrollPosition();

  return (
    <main className="w-full min-h-screen bg-gray-900">
      <CustomCursor />
      <Navbar />
      <HeroSection />
      <ExperienceSection />
      <ServicesSection/>
      <PortfolioSection />
      <ContactAndFooter />
     
    </main>
  );
};

export default App;
